import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface HealthResponseDto {
  status: string;
  timestamp: string;
}

@Injectable({
  providedIn: 'root',
})
export class HealthService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly healthBaseUrl = this.baseUrl.replace(/\/v\d+\/?$/, '');

  constructor(private http: HttpClient) {}

  getHealth(): Observable<HealthResponseDto> {
    return this.http.get<HealthResponseDto>(`${this.healthBaseUrl}/health`);
  }

  getReadiness(): Observable<HealthResponseDto> {
    return this.http.get<HealthResponseDto>(`${this.healthBaseUrl}/health/ready`);
  }
}
